<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-user-setting
    [settings]="settings$ | async"
    [categories]="categories$ | async"
    [colors]="colors$ | async"
    [timeZones]="timeZones$ | async"
    (Save)="onSave($event)"
></ef-user-setting>
